import React from 'react'
const SeccionBotones = (props) => {
	return (
	<div className={`${props.col ? props.col : "p-col-12"} ${props.extra || ""}`}>
		<div className="p-grid p-justify-end btn-row">
			{props.children}
		</div>
	</div>);
}
export default SeccionBotones;